import { useTranslation } from 'react-i18next'
import { FieldDropdown } from '@/components/form'

const LeaseTypeField = ({ isAlberta }) => {
  const { t } = useTranslation()

  return (
    <FieldDropdown
      name="lease_type"
      placeholder={t(`l.contract.edit.lease_type.label`)}
      required
      options={[
        {
          value: 'fixed',
          label: t('common.fixed_term', 'Fixed term')
        },
        ...(!isAlberta
          ? [
              {
                value: 'month_to_month',
                label: t('common.month_to_month', 'Month to month')
              }
            ]
          : [])
      ]}
    />
  )
}

export default LeaseTypeField
